export enum EButtonMode {
  DEFAULT = `default`,
  PRIMARY = `primary`,
  SECONDARY = `secondary`,
  TERTIARY = `tertiary`,
}
